import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';

const AnnouncementGrid: React.FC<GridProps> = withStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    minWidth: 140,
  },
}))(Grid);

export default AnnouncementGrid;
